
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "5 astuces pour optimiser vos title et meta-description",
    description:
      "Découvrez pourquoi l'optimisation des balises title et méta-descriptions est cruciale pour améliorer le référencement et la visibilité de votre site web.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
